import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { FamilyModel } from 'src/app/models/archive/family.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { environment } from 'src/environments/environment';
import { FamilyImportModel } from './../../models/imports/family-import.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class FamilyService {

  constructor(private _httpClient: HttpClient) { }

  createFamily(familyContractModel: FamilyModel): Observable<FamilyModel> {
    return this._httpClient.post<FamilyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.CreateFamily}`,
      familyContractModel);
  }

  deleteFamily(familyId: number): Observable<FamilyModel> {
    return this._httpClient.delete<FamilyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.DeleteFamily}/${familyId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.family.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllFamiliesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.GetAllFamiliesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getFamilyById(familyId: number): Observable<FamilyModel> {
    return this._httpClient.get<FamilyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.GetByIdAsync}/${familyId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.GetColumnsForGeneralConsultationAsync}`);
  }

  getFamilyByCode(code: string): Observable<FamilyModel> {
    const itemFilterResponse = new ItemFilterModel("code", null, null, "");
    itemFilterResponse.wildcard = code;
    return this._httpClient.post<FamilyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.GetFamilyByCode}`, itemFilterResponse);
  }

  importFamilies(familiesImports: Array<FamilyImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.ImportFamilies}`,
      familiesImports);
  }

  updateFamily(familyContractModel: FamilyModel): Observable<FamilyModel> {
    return this._httpClient.put<FamilyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.family.UpdateAsync}`,
      familyContractModel);
  }
}
